(function () {
  'use strict';
  // Lazy loader (SEO-safe perf, 2026-09-08). Everything SEO- and
  // first-paint-critical is server-rendered Liquid + a small set of eager
  // scripts. This defers the rest OFF the first-paint path:
  //   - heavy leaf features (assistant, visual search) load on first touch
  //     of their trigger — most sessions never open them;
  //   - the checkout/account/address stack loads on idle right after paint
  //     (and immediately on cart/account pages), primed earlier by any cart
  //     interaction, with a click guard so the checkout sheet still opens on
  //     the very first tap even mid-load.
  // Nothing here changes what loads eventually — only WHEN — so no feature
  // and no crawler output is affected.
  var M = window.__erosLazy || {};
  var loaded = {};

  function inject(item, onload) {
    // Stylesheet item ({ css: url }) — for CSS whose only consumers are
    // JS-created UI (auth panel, quick-buy sheet): appended as a plain <link>
    // with its group, off the render-blocking path of pages that land without
    // that UI. Order-independent, so it never gates the group's chain.
    if (item && item.css) {
      if (!loaded[item.css]) {
        loaded[item.css] = true;
        var l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = item.css;
        document.head.appendChild(l);
      }
      if (onload) onload();
      return;
    }
    var src = typeof item === 'string' ? item : item && item.src;
    if (!src) { if (onload) onload(); return; }
    if (loaded[src]) { if (onload) onload(); return; }
    loaded[src] = true;
    var s = document.createElement('script');
    s.src = src;
    // async=false on a dynamically inserted script preserves execution order
    // across a group (the checkout stack has load-order dependencies).
    s.async = false;
    if (item && item.attrs) {
      Object.keys(item.attrs).forEach(function (k) { s.setAttribute(k, item.attrs[k]); });
    }
    if (onload) s.onload = onload;
    document.head.appendChild(s);
  }

  // Load a group in order; fire `done` after the last one executes.
  function group(arr, done) {
    if (!arr || !arr.length) { if (done) done(); return; }
    var last = arr.length - 1;
    arr.forEach(function (item, i) { inject(item, i === last ? done : null); });
  }

  function idle(fn, timeout) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: timeout || 2000 });
    else window.setTimeout(fn, Math.min(timeout || 2000, 1500));
  }

  // Load `srcs` the first time the user touches something matching `selector`.
  function primeOnce(selector, srcs) {
    function fire() {
      remove();
      group(srcs);
    }
    function onPointer(e) {
      var t = e.target && e.target.closest ? e.target.closest(selector) : null;
      if (t) fire();
    }
    function onKey(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target && e.target.closest ? e.target.closest(selector) : null;
      if (t) fire();
    }
    function remove() {
      document.removeEventListener('pointerdown', onPointer, true);
      document.removeEventListener('focusin', onPointer, true);
      document.removeEventListener('keydown', onKey, true);
    }
    document.addEventListener('pointerdown', onPointer, true);
    document.addEventListener('focusin', onPointer, true);
    document.addEventListener('keydown', onKey, true);
  }

  // 1) Heavy leaf features — touch of their trigger only.
  // ADR-195 (2026-10-01): the assistant is four ordered files (storage →
  // api → panel → chat) declared as an array; a single URL (older layout
  // markup still in a cached page) keeps working through the concat.
  if (M.assistant) primeOnce('[aria-controls="eros-assistant-panel"]', [].concat(M.assistant));
  if (M.visualSearch) primeOnce('[aria-controls="eros-visual-search-panel"]', [M.visualSearch]);

  // 2) Checkout / account / address stack.
  if (M.checkout && M.checkout.length) {
    var checkoutLoading = false;
    function loadCheckout(done) {
      checkoutLoading = true;
      group(M.checkout, done);
    }
    if (M.checkoutEager) {
      // Cart / account / checkout templates: needed at load, but still async
      // (kept out of the render-blocking parse path).
      loadCheckout();
    } else {
      // Primed by any cart interaction; guaranteed by an idle fallback.
      primeOnce(
        '[aria-controls="cart-drawer"],a[href^="/cart"],[data-eros-checkout-trigger],[name="add"],form[action^="/cart/add"] [type="submit"],.eros-plp-quick-add,[data-eros-quick-add]',
        M.checkout
      );
      idle(function () { group(M.checkout); }, 2000);
    }
    // First-tap guard: the checkout button is an inert type="button" whose
    // behavior lives in eros-checkout.js (document-delegated). If tapped
    // before that script has executed, open the sheet as soon as it does,
    // so the first tap is never a dead click.
    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest ? e.target.closest('[data-eros-checkout-trigger]') : null;
      if (!trigger || window.ErosCheckout) return;
      e.preventDefault();
      e.stopPropagation();
      loadCheckout(function () {
        if (window.ErosCheckout && typeof window.ErosCheckout.open === 'function') window.ErosCheckout.open();
      });
    }, true);
  }

  // 3) Non-critical enhancements — idle after paint.
  if (M.idle && M.idle.length) idle(function () { group(M.idle); }, 2500);
})();
